<h2 mat-dialog-title *ngIf="isExistingLabel">Edit Gridics Use Tag</h2>
<h2 mat-dialog-title *ngIf="!isExistingLabel">Create Gridics Use Tag</h2>
<div class="content flex column">
    <mat-form-field class="full-width-field">
        <input matInput placeholder="Type Gridics Use Tag" [(ngModel)]="currentRecord.GridicsUse"
            (ngModelChange)="checkValidation($event)" maxlength="55">
        <mat-hint *ngIf="validationErrors" class="subscript-error">{{ validationErrors }}</mat-hint>
        <mat-hint *ngIf="!validationErrors">&nbsp;</mat-hint>
    </mat-form-field>
</div>

<mat-dialog-actions class="flex end">
    <button class="button action" [disabled]="!isValidRecord || isExecuting"
        (click)="updateRecord()">Save</button>
    <button class="button" mat-dialog-close cdkFocusInitial>Cancel</button>
</mat-dialog-actions>
